<div class="partner-redeem-container container-fluid" *ngIf="vm">
  <div class="partner-redeem-wrapper">
    <img osnSharedUseAsPicture class="background-image" [src]="vm.backgroundImgUrl" alt="" [imgQuery]="imgQuery" />
    <div class="redeem-content">
      <div class="partner-logo-wrapper">
        <img osnSharedUseAsPicture [src]="vm.logoImageUrl" alt="Partner logo" [imgQuery]="partnerLogoImgQuery" />
      </div>
      <h2 class="redeem-title">
        <span>{{ vm.mainText }}</span>
      </h2>
      <osn-shared-redeem-card #redeemCard [vm]="vm" (submitted)="onSubmit()" (loginError)="onLoginError()"></osn-shared-redeem-card>
    </div>
  </div>
</div>
